<template>
  <div>
    <acheader></acheader>
    <div class="row  mainbody">
      <div class="col-12">
        <div class="moduleWrapper">

          <!-- Orgs -->
          <div v-show="filterLength>0" v-for="n in filterLength" class="row">
            <div class="col-lg-3 col-md-6 col-sm-12" v-for="fitem in filteredOrgs(n)">
              <div class="card">
                <span v-if="fitem.ScrollElement!==null" v-bind:id="fitem.ScrollElement"></span>
                <div class="cardHeader row mb-2">
                  <div class="col-6" name="organization">
                    Organization
                  </div>
                  <div class="col-6 text-right">
                    <span v-show="fitem.IsAdmin===true" name="administrator">Administrator</span>
                  </div>
                </div>

                <div class="card-title" @click="goOrgPools(fitem.OrganizationID)" role="button" aria-label="Go to Organization Pools">
                  <h3 v-html="fitem.OrganizationName"></h3>
                </div>
                <div class="card-image text-center" @click="goOrgPools(fitem.OrganizationID)" role="button" aria-label="Go to Organization Pools">
                  <img :src="fitem.FullImage" width="80" height="80" @error="doGenericAvatar(fitem)" alt="Organization Image" />
                </div>
                <div class="card-links pool-card-links">
                  <a :href="'/organization/'+fitem.OrganizationID+'/edit'" name="edit">Edit</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                  <a :href="'/organization/'+fitem.OrganizationID+'/privileges'" name="privileges">Privileges</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                  <a :href="'/organization/'+fitem.OrganizationID+'/reporting'" name="reporting">Reporting</a><br />
                </div>
              </div>
            </div>
          </div>

          <!-- Pools -->
          <div v-show="poolLength>0">
            <div v-show="poolLength>0" v-for="n in poolLength" class="row">
              <div class="col-lg-3 col-md-6 col-sm-12" v-for="fitem in filteredPools(n)">
                <div class="card">
                  <span v-if="fitem.ScrollElement!==null" v-bind:id="fitem.ScrollElement"></span>
                  <div class="cardHeader row mb-2">
                    <div class="col-6" name="license_pool">
                      License Pool
                    </div>
                    <div class="col-6 text-right">
                      <span v-show="fitem.IsAdmin===true" name="administrator">Administrator</span>
                      <span v-show="fitem.IsAdmin!==true" name="data_viewer">Data Viewer</span>
                    </div>
                  </div>

                  <div class="card-title" @click="goPoolDash(fitem.LicensePoolID)" role="button" aria-label="Go to Pool Dashboard">
                    <h3 v-html="fitem.LicensePoolName"></h3>
                  </div>
                  <div class="card-image text-center" @click="goPoolDash(fitem.LicensePoolID)" role="button" aria-label="Go to Pool Dashboard">
                    <img :src="fitem.FullImage" width="80" height="80" @error="doGenericAvatar(fitem)" alt="Pool Image" />
                  </div>
                  <div class="card-links pool-card-links">
                    <a :href="'/pool/'+fitem.LicensePoolID+'/members'" name="member" >Members</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/pool/'+fitem.LicensePoolID+'/groups'" name="group" >Groups</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/pool/'+fitem.LicensePoolID+'/products'" name="products" >Products</a><br />
                    <a :href="'/pool/'+fitem.LicensePoolID+'/bundles'" name="bundles">Bundles</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/pool/'+fitem.LicensePoolID+'/pooltrainingplans'"name="training_plans">Training Plans</a>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- Groups -->
          <div v-show="groupLength>0">
            <div v-show="groupLength>0" v-for="n in groupLength" class="row">
              <div class="col-lg-3 col-md-6 col-sm-12" v-for="fitem in filteredGroups(n)">
                <div class="card">
                  <span v-if="fitem.ScrollElement!==null" v-bind:id="fitem.ScrollElement"></span>

                  <div class="cardHeader row mb-2">
                    <div class="col-6" name="group">
                      Group
                    </div>
                    <div class="col-6 text-right">
                      <span v-show="fitem.IsAdmin===true" name="administrator">Administrator</span>
                      <span v-show="fitem.IsAdmin!==true" name="data_viewer">Data Viewer</span>
                    </div>
                  </div>

                  <div class="card-title" @click="goGroupDash(fitem.LicensePoolGroupID)" aria-label="Go to Group Dashboard" role="button">
                    <h3 v-html="fitem.LicensePoolGroupName"></h3>
                  </div>
                  <div class="card-image text-center" @click="goGroupDash(fitem.LicensePoolGroupID)" aria-label="Go to Group Dashboard" role="button">
                    <img :src="fitem.FullImage" width="80" height="80" @error="doGenericAvatar(fitem)" alt="Pool Image" />
                  </div>

                  <div class="card-links pool-card-links">
                    <a :href="'/group/'+fitem.LicensePoolGroupID+'/members'" name="member">Members</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                    <a :href="'/group/'+fitem.LicensePoolGroupID+'/subgroups'" name="subgroups">Subgroups</a>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
    <b-modal title="Announcements" ref="announceModal" size="xl" ok-only @ok="finishedAnnouncements">
        <div v-for="announce in announces">
            <h2>{{announce.Title}}</h2>
            <p>Date: {{announce.AnnouncementDate}}</p>
            <p>{{announce.Message}}</p>
        </div>
    </b-modal>
    <acfooter></acfooter>
  </div>
</template>
<style scoped>
  .card-title {
    margin-top:40px;
  }
  .pool-card-links {
      margin-top:25px;
  }
  .pool-card-links button {
     width:150px;
  }
</style>
<script>
  import acheader from "../layout/Header.vue"
  import acfooter from "../layout/Footer.vue"
  export default {
    name: 'Dashboard',
    components:{acheader,acfooter},
    data() {
      return {
        announces:[],
        filterLength:0,
        poolLength:0,
        groupLength:0,
        modgroups:[]
      }
    },
    methods: {
      doGenericAvatar: function(pool) {
        pool.FullImage="/pool.svg";
        this.$forceUpdate();
      },
      filteredGroups: function(n) {
        return this.modgroups.slice((n-1)*4, (n-1)*4+4)
      },
      filteredPools: function(n) {
        return this.sdata.allpools.slice((n-1)*4, (n-1)*4+4)
      },
      filteredOrgs: function (n) {
        return this.sdata.allorgs.slice((n-1)*4, (n-1)*4+4)
      },
      goGroupDash: function(groupid) {
        this.$router.push({ name: 'groupdash', params: {id: groupid}});
      },
      goOrgPools: function(orgid) {
        this.$router.push({ name: 'orgpools', params: { id: orgid } });
      },   
      goOrgXfer: function(orgid) {
        this.$router.push({ name: 'orgtransfer', params: { id: orgid } });
      },
      goOrgHistory: function(orgid) {
        this.$router.push({ name: 'orgorderhistory', params: { id: orgid } });
      },  
      goPoolDash: function(poolid) {
        this.$router.push({ name: 'pooldash', params: { id: poolid } });
      },
   
      goToPools: function(orgid) {
        this.$router.push({ name: 'orgpools', params: { id: orgid } });
      },
      finishedAnnouncements: function() {
        this.finishDash();
      },
      finishDash: function() {
        if (this.sdata.allorgs.length===0) {
        
          if (this.sdata.allpools.length===1) {
            if (this.sdata.allgroups.filter(p=>p.LicensePoolID!==this.sdata.allpools[0].LicensePoolID).length===0) {
              this.$router.push("/pool/"+this.sdata.allpools[0].LicensePoolID+"/dashboard");
            }
          }
          else if (this.sdata.allgroups.length===1) {
            this.$router.push("/group/"+this.sdata.allgroups[0].LicensePoolGroupID+"/dashboard");
          }
        }       
        try {
          if (typeof(this.sdata.poolthemes)!=="undefined"&&this.sdata.poolthemes!==null&&this.sdata.poolthemes.length>0&&this.sdata.isemployee!==true) {
      
            if (this.sdata.poolthemes[0].UsesBranding) {
              this.applyTheme(this.sdata.poolthemes[0]);
            }
        
          }
        }
        catch(e) {}


        this.$bus.$emit("AvatarUpdateEvent",this.udata);
        this.$bus.$emit("BreadcrumbUpdateEvent",this.sdata.allorgs,this.sdata.allpools,this.sdata.allgroups,null,null,null);

        if (this.sdata.allorgs.length>=4) {
          if (this.sdata.allorgs.length%4>0) {
            this.filterLength = (this.sdata.allorgs.length-(this.sdata.allorgs.length%4))/4+1;
          }
          else {
            this.filterLength = this.sdata.allorgs.length/4;
          }
    
        }
        else if (this.sdata.allorgs.length>0) {
          this.filterLength=1;
        }

        // Pool/group view for non org administrators
        if (this.sdata.allorgs.length===0) {

          if (this.sdata.allpools.length>=4) {
            if (this.sdata.allpools.length%4>0) {
              this.poolLength = (this.sdata.allpools.length-(this.sdata.allpools.length%4))/4+1;
            }
            else {
              this.poolLength = this.sdata.allpools.length/4;
            }
    
          }
          else if (this.sdata.allpools.length>0) {
            this.poolLength=1;
          }

          for (var group of this.sdata.allgroups) {            
            if (this.sdata.allpools.filter(p => p.LicensePoolID === group.LicensePoolID).length === 0 && group.ParentID == '00000000-0000-0000-0000-000000000000') {              
              this.modgroups.push(group);
            }
          }

          if (this.modgroups.length>=4) {
            if (this.modgroups.length%4>0) {
              this.groupLength = (this.modgroups.length-(this.modgroups.length%4))/4+1;
            }
            else {
              this.groupLength = this.modgroups.length/4;
            }
    
          }
          else if (this.modgroups.length>0) {
            this.groupLength=1;
          }

        }
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.apiCommand([{
          Operation: "Client",
          Function: "AddPublicAnnouncementClient",
          Fields: {
            ClientID: this.udata.ClientID,
            PortalType:1
          }
        }]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          var announcements=JSON.parse(cr.returnObjects[0].returnObject);

          if (announcements.length>0) {
            for(var a of announcements) {
              a.AnnouncementDate=this.buildDateTime(a.AnnouncementDate,false);
            }
            this.announces=announcements;
            this.$refs.announceModal.show();
          }
          else {
            this.finishDash();
          }
          Window.loadLanguageContent();
        });  
      });
    
    }
  }
</script>
